import { render, staticRenderFns } from "./SponsorTransactionHistory.vue?vue&type=template&id=9e30ae4a&"
import script from "./SponsorTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./SponsorTransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./SponsorTransactionHistory.vue?vue&type=style&index=0&id=9e30ae4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports